<template>
  <div class="bg-white px-6 2xl:px-24 py-40">
    <h3 class="max-w-4xl text-black">{{ $t('PROTECT_ALL_YOUR_DEVICES') }}</h3>

    <ul class="flex flex-wrap justify-start w-full mt-24">
      <li
        v-for="item in items"
        :key="item.platform"
        class="flex flex-col justify-end py-16 px-8 bg-white text-black"
        :class="{'cursor-not-allowed': item.soon}"
      >
        <div
          :class="{'opacity-50 cursor-not-allowed': item.soon}"
          class="overflow-hidden mb-6 platform-icon object-contain w-20 h-20 flex items-end justify-center"
        >
          <img :src="getLogo(item.platform)" class="h-full" alt="">
        </div>

        <div class="text-left">
          <h6 :class="{'opacity-50': item.soon}" class="text-left mb-2">
            {{ getTitle(item.platform) }}
          </h6>
          <span :class="{'opacity-50': item.soon}" class="text-left block my-3">
            {{ getDescription(item.platform) }}
          </span>

          <a v-if="item.url && !item.soon" :href="item.url" target="_blank" class="p-0 text-left inline-block underline">
            {{ getExternalCallout(item.platform) }}
          </a>

          <span class="font-bold" v-if="item.soon">
            {{ $t('AVAILABLE_SOON') }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';

defineProps({
  description: { type: String, required: false, default: () => '' },
  items: { type: Array as PropType<Array<{ platform: 'android' | 'ios' | 'windows' | 'linux' | 'macos', url: string, soon?: Boolean }>>, required: true, default: () => [] },
});

const { t } = useI18n();

function getTitle(platform: string) {
  return t(platform.toUpperCase())
}


function getDescription(platform: string) {
  return t('PLATFORM_AVAILABLE_DESC_' + platform.toUpperCase())
}


function getExternalCallout(platform: string) {
  if (['windows', 'linux', 'macos'].includes( platform)) {
    return t('DOWNLOAD_NOW')
  }

  return t('VISIT_EXTERNAL_' + platform.toUpperCase())
}

function getLogo(platform: string) {
  let path = 'https://assets.nuinalp.com/3rd/';

  const paths = {
    'android': 'android-logo-2023.svg ',
    'ios': 'ios_wordmark.svg',
    'windows': 'windows_logo_2021.svg',
    'linux': 'linux_logo.svg',
    'macos': 'macos_logo.svg',
  }

  return path + paths[platform as keyof typeof paths];
}
</script>

<style lang="scss" scoped>
ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  li {
    outline: 1px dashed black;
  }
}


@media (screen(lg)) {
  ul {

    li {
      height: 390px;

    div:last-child {
      height: 140px;
      }
    }
  }
}


a {
  text-decoration: none;
  color: inherit;
}


.platform-icon {
  width: 66px;
  height: 66px;
}
</style>